import React from 'react';

import { DateRange } from 'react-day-picker';

import DatePicker from 'components/DatePicker/DatePicker';
import { DatePickerMode } from 'components/DatePicker/DatePicker.types';
import FilterCommandCard from 'components/Filter/FilterCommandCard';

interface ABTestTabHeaderProps {
  attributeNameOptions: Array<{ label: string; value: string }>;
  attributeValueOptions: Array<{ label: string; value: string; disabled?: boolean }>;
  selectedAttributeName?: string;
  selectedAttributeValues: string[];
  dateRange: DateRange;
  isLoadingAttributeNames: boolean;
  isLoadingAttributeValues: boolean;
  onAttributeNameChange: (value: string | undefined) => void;
  onAttributeValuesChange: (values: string[]) => void;
  onDateRangeChange: (dateRange: DateRange) => void;
}

const ABTestTabHeader: React.FC<ABTestTabHeaderProps> = ({
  attributeNameOptions,
  attributeValueOptions,
  selectedAttributeName,
  selectedAttributeValues,
  dateRange,
  isLoadingAttributeNames,
  isLoadingAttributeValues,
  onAttributeNameChange,
  onAttributeValuesChange,
  onDateRangeChange,
}) => {
  return (
    <div className="w-full flex justify-between items-center pb-2">
      <div className="flex items-center gap-2">
        <FilterCommandCard
          header="Attribute Name"
          options={attributeNameOptions}
          filterValue={selectedAttributeName}
          setFilterValue={onAttributeNameChange}
          isLabelSearchBy
          isLoading={isLoadingAttributeNames}
        />
        <FilterCommandCard
          header="Attribute Values"
          options={attributeValueOptions}
          filterValue={selectedAttributeValues}
          setFilterValue={onAttributeValuesChange}
          isMulti
          maxSelections={4}
          disabled={!selectedAttributeName || selectedAttributeName.length === 0}
          isLoading={isLoadingAttributeValues}
        />
      </div>
      <div className="flex items-center w-auto gap-2">
        <DatePicker
          shouldDisplayTime={false}
          mode={DatePickerMode.RANGE}
          value={dateRange}
          onApply={(value) => onDateRangeChange(value as DateRange)}
          shouldExcludeFuture
        />
      </div>
    </div>
  );
};

export default ABTestTabHeader; 